module.exports = __webpack_public_path__ + "static/img/Danny.Corcoran.7938152.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Danny.Corcoran.jpg
// module id = CVzH
// module chunks = 0